import { SchoolSearchCard } from "components/schools/SchoolSearchCard/SchoolSearchCard";
import { isProduction } from "scripts/application/setting";
import { IPropertyId } from "types/artifacts/common";
import { ISchoolSearchArtifact } from "types/artifacts/search-schools";
import { IArtifactComponentProps } from "types/services";
import { findArtifactByHarid } from "utils/helpers";

export type ISearchSchoolsOutputProps = IArtifactComponentProps<
  IPropertyId,
  ISchoolSearchArtifact
>;

SearchSchoolsOutput.artifactKey = "property_detail";

export function SearchSchoolsOutput(
  props: ISearchSchoolsOutputProps
): JSX.Element {
  const { harid, artifacts } = props;

  // if there is no valid artifacts return from the backend
  if (!Array.isArray(artifacts)) return <></>;

  if (harid) {
    const artifact = findArtifactByHarid(artifacts, harid);
    const { description, elementary_school, high_school, middle_school } = artifact?.response?.schools ?? {};
    const schools = [
      ...(elementary_school ? [elementary_school] : []),
      ...(middle_school ? [middle_school] : []),
      ...(high_school ? [high_school] : [])
    ];
    const schoolsCount = schools?.length || 0;
    const transformedSchools = schools.map((school) => ({
      // ...school,
      school_id: school.id,
      school_name: school.name,
      district_name: school.district_name,
      street_address: school.address,
      url: school.url,
      grade: school.grade_span || "",
      rating: {
        // ...school.rating,
        score: school.rating_score,
        text: school.rating_text,
        badges: school.badges || [],
        index: school.rating?.index || 0
      },
      grade_span: school.grade_span || null,
      location: school.location || [0, 0],
      // maxWidth: 300 // Default maxWidth if not provided
    }));

    if (artifact && schoolsCount > 0) {
      return <SchoolSearchCard.Carousel {...artifact} schools={transformedSchools} schoolsCount={schoolsCount} />;
    }

    console.error(
      "No artifact or schools found for 'SearchSchoolsOutput' with the given harid:",
      harid
    );

    return <></>;
  }

  console.error(
    "No harid provided for 'SearchSchoolsOutput'."
  );

  return <></>;
}

SearchSchoolsOutput.asText = function (props: ISearchSchoolsOutputProps): string {
  // console.log("SearchSchoolsOutput.asText", props);
  return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.schools?.artifact_text || "" : isProduction ? "" : "SearchSchoolsOutput asText Not Implemented!";
}